<template>
  <div role="tablist">
    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block href="#" v-b-toggle.search-accordion variant="info">Recherche d'article(s) de blog</b-button>
      </b-card-header>
      <b-collapse id="search-accordion" accordion="blog-accordion" role="tabpanel">
        <b-card-body>
          <Search />
        </b-card-body>
      </b-collapse>
    </b-card>

    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block href="#" v-b-toggle.subscription-accordion variant="info">S'abonner à l'infolettre</b-button>
      </b-card-header>
      <b-collapse id="subscription-accordion" accordion="blog-accordion" role="tabpanel">
        <b-card-body>
          <SubscriptionForm />
        </b-card-body>
      </b-collapse>
    </b-card>
    </div>
</template>

<script>
import SubscriptionForm from '@/components/SubscriptionForm.vue'
import Search from '@/components/Search.vue'

export default {
  props: [
    'articles',
    'article'
  ],
  components: {
    SubscriptionForm,
    Search
  },
  data() {
    return {

    }
  },
  computed: {},
  mounted() {},
  methods: {}
}
</script>

<style scoped>
.card,
.card-header {
  background-color: transparent;
  border: none;
}

.card-header > .btn {
  border-radius: 0;
}
</style>
